import { Component } from '@angular/core';
import { CurrentLoginStylingService } from '@modules/common/services/current-login-styling.service';
import { dashFormatPhoneNumber } from '@modules/common/functions/dash-format-phone-number';

@Component({
    selector: 'app-login-footer-help',
    templateUrl: './login-footer-help.component.html',
    styleUrls: ['./login-footer-help.component.scss']
})
export class LoginFooterHelpComponent {
    public email: string = '';
    public callCenterPhoneNumbers:CallCenterPhoneNumber[] = [];

    private static DEFAULT_EMAIL: string = 'loginsupport@winstonbenefits.com';
    private static DEFAULT_PHONE_NUMBER: string = '1-732-899-0990';

    constructor(
        private _currentLoginStylingService: CurrentLoginStylingService
    ) { }

    public ngOnInit(): void {
        this._currentLoginStylingService.configChanged.subscribe(result => {
            if (result && result.contactEmail) {
                this.email = result.contactEmail;
            } else {
                this.email = LoginFooterHelpComponent.DEFAULT_EMAIL;
            }

            this.callCenterPhoneNumbers = [];

            if (result?.caseCallCenterPhoneNumbers) {
                result.caseCallCenterPhoneNumbers.forEach(x => {
                    this.callCenterPhoneNumbers.push({
                        name: x!.name,
                        phoneNumber: dashFormatPhoneNumber(x!.phoneNumber!)
                    });
                });
            }

            if(this.callCenterPhoneNumbers!.length == 0){
                this.callCenterPhoneNumbers.push({
                    phoneNumber: dashFormatPhoneNumber(LoginFooterHelpComponent.DEFAULT_PHONE_NUMBER)
                });
            }
        });
    }
}

interface CallCenterPhoneNumber{
    name?: string;
    phoneNumber:string;
} 
